// @flow

import loggedIn from 'app/developer-v3/components/PartnerSupportForm/content/nodes/loggedIn';
import loggedOut from 'app/developer-v3/components/PartnerSupportForm/content/nodes/loggedOut';
import login from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Login';

const root = login({
  loggedIn,
  loggedOut,
});

export default root;
